module.exports = __webpack_public_path__ + "static/media/big_smartsampa_logo_light.b1c40ca6.png";